import { Auth } from '@prismamedia/one-components';
import { Role } from '@prismamedia/one-user';
import { TagType } from '../__generated__/queries-web';

export const auth = new Auth(config.API_ONE_AUTH);

const hasWebAdminCreationRole = () =>
  !!auth.user &&
  (auth.user.isSuperAdmin() ||
    auth.user.isAdmin() ||
    auth.user.hasRole(Role.WebAdmin));

export const canCreateTag = (tagProviders: TagType[] = []) => {
  if (
    !auth.isAuthenticated() ||
    !tagProviders.find((tagProvider) => {
      return [TagType.Tag, TagType.Video].includes(tagProvider);
    })
  ) {
    return false;
  }

  return hasWebAdminCreationRole();
};

export const canCreateCategory = () =>
  auth.isAuthenticated() && hasWebAdminCreationRole();
